// extracted by mini-css-extract-plugin
export default {"simpleText":"SimpleText_simpleText__dXPjm"};